var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.transcript),function(t){return _c('div',[(_vm.isConversational && _vm.getHeader(t))?_c('h4',[_vm._v("\n      "+_vm._s(_vm.getHeader(t))+"\n    ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(t.text))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }